import React from 'react';
import { Spinner } from 'components/UI';
import styles from './PetBreakdownDetailTable.module.css';

interface PetBreakdownData {
    petType: string;
    petBreed: string;
    totalBookings: number;
    netSales: number;
    avgTicket: number;
}

interface PetBreakdownDetailTableProps {
    loading: boolean;
    data: PetBreakdownData[] | null;
}

export const PetBreakdownDetailTable: React.FunctionComponent<PetBreakdownDetailTableProps> = props => {
    const formatCurrency = (amount: number) => {
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    return (
        <div className={styles.root}>
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead className={styles.header}>
                        <tr>
                            <th className={styles.headerCell}>Pet Type</th>
                            <th className={styles.headerCell}>Pet Breed</th>
                            <th className={styles.headerCell}>Total Bookings</th>
                            <th className={styles.headerCell}>Net Sales</th>
                            <th className={styles.headerCell}>Avg Ticket</th>
                        </tr>
                    </thead>
                    <tbody className={styles.body}>
                        {props.loading ? (
                            <tr>
                                <td
                                    colSpan={5}
                                    className={styles.loadingCell}
                                >
                                    <Spinner className={styles.spinner} />
                                </td>
                            </tr>
                        ) : (
                            props.data?.map((item, index) => (
                                <tr
                                    key={index}
                                    className={styles.row}
                                >
                                    <td className={styles.cell}>{item.petType}</td>
                                    <td className={styles.cell}>{item.petBreed}</td>
                                    <td className={styles.cell}>{item.totalBookings}</td>
                                    <td className={styles.cell}>{formatCurrency(item.netSales)}</td>
                                    <td className={styles.cell}>{formatCurrency(item.avgTicket)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PetBreakdownDetailTable;
